import { gql } from 'graphql-request';

export const getAllCurrencyRatesQuery = gql`
  query GetAllCurrencyRates {
    allCurrencyRates {
      date
      currencyRates {
        CHF_USD
        EUR_USD
        GBP_USD
        ILS_USD
        CAD_USD
      }
    }
  }
`;
